import { render, staticRenderFns } from "./RecipientsBulkOptionsUploadCard.vue?vue&type=template&id=56c92e16&scoped=true"
import script from "./RecipientsBulkOptionsUploadCard.vue?vue&type=script&lang=ts"
export * from "./RecipientsBulkOptionsUploadCard.vue?vue&type=script&lang=ts"
import style0 from "./RecipientsBulkOptionsUploadCard.vue?vue&type=style&index=0&id=56c92e16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c92e16",
  null
  
)

export default component.exports